// extracted by mini-css-extract-plugin
export default {"root":"InputButton-module_root__mKJ9O"};